import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { AppWrapper } from "./components/common/PageMeta";

// Function to dynamically set the favicon
const setDynamicFavicon = async () => {
  try {
    const token = sessionStorage.getItem("access_token");
    if (!token) {
      return;
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/setting/edit`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await response.json();

    if (result.status === 200 && result.data.length > 0) {
      const data = result.data[0];
      const logoPath = data.logo_path;
      const logoName = data.logoname;

      if (logoPath && !logoPath.includes("null") && logoPath.trim() !== "") {
        // Set favicon
        let link = document.querySelector("link[rel*='icon']");
        if (!link) {
          link = document.createElement("link");
          document.head.appendChild(link);
        }
        const faviconLink = link as HTMLLinkElement;
        faviconLink.type = "image/png";
        faviconLink.rel = "icon";
        faviconLink.href = `${logoPath}?v=${Date.now()}`; // prevent caching
      }

      // Set browser tab title
      const isValidLogoName =
        typeof logoName === "string" &&
        logoName.trim() !== "" &&
        logoName.trim().toLowerCase() !== "null";

      if (isValidLogoName) {
        document.title = `${logoName.trim()} | Powered by KloudData`;
      } else {
        document.title = "Powered by KloudData";
      }
    }
  } catch (error) {
    console.error("Error setting favicon and title:", error);
  }
};

// Call favicon setup before rendering
setDynamicFavicon();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <AppWrapper>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </AppWrapper>
  </React.StrictMode>
);

reportWebVitals();
